export default __webpack_public_path__ + "static/media/space-bg.5a7399e5.png";